import IsPasswordNotBlacklisted from '@/services/cms/passwordService/IsPasswordNotBlacklisted';

export default class PasswordService {
    static isPasswordNotBlacklisted(password) {
        return (new IsPasswordNotBlacklisted()).handle(password);
    }
}
